// Supabase возвращает ошибку OAuth не в теле, а в адресе — и в query, и в hash. Без разбора человек
// видит форму входа и ноль объяснений, а мусор остаётся в адресной строке.
const TEXTS: Record<string, string> = {
  signup_disabled: 'This account is not registered yet. Ask the roadmap owner to add you.',
  access_denied: 'Google sign-in was cancelled.',
  unexpected_failure: 'Google sign-in failed on our side. Try again; if it repeats, tell the roadmap owner.',
};

/** Текст ошибки входа из адреса или null. search и hash — как у window.location. */
export function authErrorFromUrl(search: string, hash: string): string | null {
  const qs = new URLSearchParams(search);
  const hs = new URLSearchParams(hash.replace(/^#/, ''));
  const pick = (k: string) => qs.get(k) || hs.get(k);
  const code = pick('error_code') || pick('error');
  if (!code) return null;
  return TEXTS[code] ?? pick('error_description') ?? code;
}

/** Есть ли в адресе ошибка входа: только тогда адрес чистим — при удачном входе там токены, которые ещё разберёт supabase-js. */
export const hasAuthError = (search: string, hash: string): boolean => authErrorFromUrl(search, hash) !== null;
